module.exports = __webpack_public_path__ + "media/Video (5).43304a4a.mp4";